import React from 'react';
import useUser from '../stores/useUser';
import styles from './AdminProfileLink.scss'
import Button from "./MaterialUi/Button";

export interface IAdminProfileLinkProps {
    id: string;
    
}

const AdminProfileLink: React.FC<React.PropsWithChildren<IAdminProfileLinkProps>> = ({ id = null }) => {
    const [user] = useUser();
    const propertyEdit = window.location.href + "/edit";
    
    return (
        <div className={styles.AdminProfileLink}> 
            { user.isAdmin && (
                // <div className={styles.AdminProfileLink}>
                <div>
                    <Button href={`/user/${id}`}>Zum User-Profil</Button>
                </div>
            )}

            {((user.uid)?.toString() == id  || user.isAdmin) && (
                <div><Button color="primary" href= {propertyEdit}>Immobilie bearbeiten</Button></div>
            )}
         
        </div>)
};

export default AdminProfileLink;
